<template lang="pug">
#toolbar(role="tablist")
  b-navbar(
    toggleable="md",
    :class="{ 'bb-1': scrolled || toggled, 'overlap-image': isHome && !scrolled && !toggled }"
  )
    .padding_menu.align-items-center
      b-navbar-brand(:to="{ name: 'home' }")
        b-img(
          :src="coloredLogo",
          height="45",
          alt="logo_scape_masajes_domicilio"
        )
      b-navbar-toggle.b-0(target="toolbar-menu")
        bar-chart-2-icon.menu-icon(
          style="transform: rotate(-90deg)",
          :class="isHome && !scrolled && !toggled ? 'menu-icon-white' : null"
        )
    .flex-grow-1.container_menu
      b-collapse#toolbar-menu(is-nav)
        transition(name="fade", mode="out-in")
          #main.navbar_section(v-if="menu_section == 'main'", key="main")
            .toolbar-links
              b-navbar-nav.d-flex(style="flex: 0 0 auto")
                b-nav-form
                  b-button(variant="info", :to="{ name: 'account' }", pill, style="-webkit-text-fill-color: white; padding: 3px 10px") {{ user ? $t('toolbar.account') : $t('toolbar.login')}}
            .header_footer.d-md-none
              .shortcut_container
                .shortcuts 
                  .shortcut_title.mb-2 {{ $t('toolbar.shortcuts') }}
                  .shortcut_body {{ $t('toolbar.gifts') }}:
                    span(style="float: right; color: gray") 
                      b-link(:to="{ name: 'purchase' }") {{ $t('toolbar.buy') }}
                      span |
                      b-link(:to="user ? isUser.to : notUser.to") {{ $t('toolbar.exchange') }}
                b-button(
                  variant="info",
                  :to="{ name: 'account' }",
                  pill,
                  style="-webkit-text-fill-color: white; padding: 3px 10px; width: 60%"
                ) {{ user ? $t('toolbar.account') : $t('toolbar.login')}}
          #colabs.navbar_section(
            v-else-if="menu_section == 'colabs'",
            key="colabs"
          )
            .toolbar-links
              b-navbar-nav.toolbar-links.d-flex.justify-content-around.align-items-center(
                style="flex: 0.7 0 auto"
              )
                b-nav-item.return_link(@click="menu_section = 'main'") {{ $t('toolbar.colab') }}
                  chevron-left-icon(style="float: left")
                b-nav-item(:to="{ name: 'lbeaute' }") L´Beauté
                  chevron-right-icon(style="float: right")
                b-nav-item(:to="{ name: 'foreo' }") Foreo
                  chevron-right-icon(style="float: right")
                b-nav-item(:to="{ name: 'bisse_groom' }") The Ultimate Grooming
                  chevron-right-icon(style="float: right")
                b-nav-item(:to="{ name: 'bisse_ener' }") Energizing C + C
                  chevron-right-icon(style="float: right")
            .header_footer.d-md-none
              h5.text-center.mt-0(style="font-weight: 700") {{ $t('toolbar.colab') }}
              .shortcut_body {{ $t('toolbar.colab_desc') }}
              b-row.mt-4
                b-col.text-right(cols="6")
                  b-img.image_menu(
                    src="@/assets/lbeaute-menu.png",
                    @click="$router.push({ name: 'lbeaute' })"
                  )
                b-col.text-left(cols="6")
                  b-img.image_menu(
                    src="@/assets/foreo-menu.png",
                    @click="$router.push({ name: 'foreo' })"
                  )
                b-col.text-right(cols="6")
                  b-img.image_menu(
                    src="@/assets/grooming-menu.png",
                    @click="$router.push({ name: 'bisse_groom' })"
                  )
                b-col.text-left(cols="6")
                  b-img.image_menu(
                    src="@/assets/energizing-menu.png",
                    @click="$router.push({ name: 'bisse_ener' })"
                  )
          #services.navbar_section(v-else, key="services")
            .toolbar-links
              b-navbar-nav.toolbar-links.d-flex.justify-content-around.align-items-center(
                style="flex: 0.7 0 auto"
              )
                b-nav-item.return_link(@click="menu_section = 'main'") {{ $t('toolbar.services') }}
                  arrow-left-icon(style="float: left")
                b-nav-item(
                  :to="$route.name != 'services' ? { name: 'services', hash: '#masajes' } : null",
                  @click="scrollTo('#masajes')"
                ) {{ $t('toolbar.massage') }}
                  chevron-right-icon(style="float: right")
                b-nav-item(
                  :to="$route.name != 'services' ? { name: 'services', hash: '#faciales' } : null",
                  @click="scrollTo('#faciales')"
                ) {{ $t('toolbar.facials') }}
                  chevron-right-icon(style="float: right")
                b-nav-item(
                  :to="$route.name != 'services' ? { name: 'services', hash: '#paquetes' } : null",
                  @click="scrollTo('#paquetes')"
                ) {{ $t('toolbar.combo') }}
                  chevron-right-icon(style="float: right")
            .header_footer.d-md-none
              .shortcut_container
                .shortcuts 
                  .shortcut_title.mb-2 {{ $t('toolbar.shortcuts') }}
                  .shortcut_body {{ $t('toolbar.gifts') }}:
                    span(style="float: right; color: gray") 
                      b-link(:to="{ name: 'purchase' }") {{ $t('toolbar.buy') }}
                      span |
                      b-link(:to="user ? isUser.to : notUser.to") {{ $t('toolbar.exchange') }}
                b-button(
                  variant="info",
                  :to="{ name: 'account' }",
                  pill,
                  style="-webkit-text-fill-color: white; padding: 3px 10px; width: 60%"
                ) {{ user ? $t('toolbar.account') : $t('toolbar.login')}}
  b-collapse#menu-colabs(accordion="my-accordion", role="tab")
    .drop_container.d-none.d-md-flex
      .mr-5(style="width: 200px")
        .shortcut_title.border_title.mb-2 {{ $t('toolbar.shortcuts') }}
        p {{ $t('toolbar.gifts') }}:
        p 
          b-link(:to="{ name: 'purchase' }") {{ $t('toolbar.buy') }}
          span |
          b-link(:to="user ? isUser.to : notUser.to") {{ $t('toolbar.exchange') }}
      .drop_options.d-none.d-md-flex(style="flex-wrap: wrap")
        router-link.option_colab.mr-5(
          :to="{ name: 'lbeaute' }",
          v-b-toggle.menu-colabs
        )
          .shortcut_title.border_title.mb-2 L'Beaute
          p Facial Mona Lisa / Venus de Milo
        router-link.option_colab.mr-5(
          :to="{ name: 'foreo' }",
          v-b-toggle.menu-colabs
        )
          .shortcut_title.border_title.mb-2 Foreo
          p Hidrofacial
        .option_colab(style="cursor: default")
          .shortcut_title.border_title.mb-2 Natura Bissé
          b-link(:to="{ name: 'bisse_groom' }", v-b-toggle.menu-colabs) The Ultimate Grooming
          br
          b-link(:to="{ name: 'bisse_ener' }", v-b-toggle.menu-colabs) Energizing C + C
  b-collapse#menu-services(accordion="my-accordion", role="tab")
    .drop_container.d-none.d-md-flex
      .mr-5(style="width: 200px")
        .shortcut_title.border_title.mb-2 {{ $t('toolbar.shortcuts') }}
        p {{ $t('toolbar.gifts') }}:
        p 
          b-link(:to="{ name: 'purchase' }") {{ $t('toolbar.buy') }}
          span |
          b-link(:to="user ? isUser.to : notUser.to") {{ $t('toolbar.exchange') }}
      .option_colab.mr-5(@click="scrollTo('#masajes')")
        .shortcut_title.border_title.mb-2 {{ $t('toolbar.massage') }}
        p {{ $t('toolbar.massage') }}
      .option_colab.mr-5(@click="scrollTo('#faciales')")
        .shortcut_title.border_title.mb-2 {{ $t('toolbar.facials') }}
        p {{ $t('toolbar.facials') }}
      .option_colab(@click="scrollTo('#paquetes')")
        .shortcut_title.border_title.mb-2 {{ $t('toolbar.combo') }}
        p {{ $t('toolbar.combo') }}
</template>

<script>
import VueScrollTo from "vue-scrollto";
import { mapState } from "vuex";

export default {
  props: {
    type: {
      type: String,
      default: "white",
    },
    isHome: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      scrollTop: 1,
      scrolled: false,
      collapse_list: {
        services: false,
        colabs: false,
      },
      isUser: {
        to: "nuevo-servicio",
      },
      notUser: {
        to: "mi-cuenta/inicio-sesion",
      },
      toggled: false,
      menu_section: "main",
    }
  },
  computed: {
    ...mapState("context", ["user"]),
    coloredLogo() {
      if (
        this.isHome &&
        !this.scrolled &&
        !this.toggled &&
        this.$breakpoint.smDown
      ) {
        return require("@/assets/logo-white.png");
      } else if (this.scrolled || this.type == "black") {
        return require("@/assets/logo_blue.png");
      } else {
        return require("@/assets/logo-white.png");
      }
    },
  },
  methods: {
    scrollTo(section) {
      if (this.toggled)
        this.$root.$emit("bv::toggle::collapse", "menu-services");
      if (this.$route.name == "services") {
        VueScrollTo.scrollTo(section, 500, {
          offset: -70,
          force: true,
        });
      } else {
        this.$router.push({ name: "services", hash: section });
      }
    },
    toggleColabs() {
      if (
        this.$route.name == "colab" ||
        this.$route.name == "lbeaute" ||
        this.$route.name == "foreo" ||
        this.$route.name == "bisse_groom" ||
        this.$route.name == "bisse_ener"
      )
        this.$root.$emit("bv::toggle::collapse", "menu-colabs");
      else this.$router.push({ name: "colab" });
    },
  },
  mounted() {
    let self = this
    document.getElementById("toolbar").setAttribute("data-style", "transparent");
    document.getElementById("toolbar").setAttribute("data-type", this.type);

    document.addEventListener("scroll", function () {
      if (
        document.getElementsByTagName("html")[0].scrollTop >= self.scrollTop
      ) {
        document.getElementById("toolbar").setAttribute("data-style", "white");
        document.getElementById("toolbar").setAttribute("data-type", "black");
        self.scrolled = true;
      } else {
        self.scrolled = false;
        if (!self.toggled) {
          document
            .getElementById("toolbar")
            .setAttribute("data-style", "transparent");
          document
            .getElementById("toolbar")
            .setAttribute("data-type", self.type);
        }
      }
    });

    this.$root.$on("bv::collapse::state", (collapseId, isJustShown) => {
      if (collapseId == "menu-services")
        self.collapse_list.services = isJustShown;
      else self.collapse_list.colabs = isJustShown;
      if (self.collapse_list.services || self.collapse_list.colabs) {
        document.getElementById("toolbar").setAttribute("data-style", "white");
        document.getElementById("toolbar").setAttribute("data-type", "black");
        self.toggled = true;
      } else {
        self.toggled = false;
        if (!self.scrolled) {
          document
            .getElementById("toolbar")
            .setAttribute("data-style", "transparent");
          document
            .getElementById("toolbar")
            .setAttribute("data-type", self.type);
        }
      }
    });

    this.$nextTick(() => {
      setTimeout(() => {
        if (this.$route.hash) {
          this.scrollTo(this.$route.hash);
        }
      }, 1000);
    });
  },
};
</script>

<style lang="scss" scoped>
#toolbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 11;
  transition: all 0.3s !important;
  white-space: pre-line;
}

.drop_container {
  width: 100%;
  background: #f3f3f4;
  padding: 20px 5% 50px 5%;
  display: flex;
}

.drop_options {
  width: 100%;
  background: #f3f3f4;
  display: flex;
}

.option_colab {
  width: 200px;
  cursor: pointer;
  color: black;
}

.option_colab:hover {
  color: rgba(0, 0, 0, 0.5);
  text-decoration: none;
}

.border_title {
  border-bottom: 1px solid black;
}

a {
  color: #4a4a4a;
}

.drop_container p {
  margin-bottom: 0;
}

.fade-leave-active,
.fade-enter-active {
  transition: 0.2s;
}

.fade-enter {
  transform: translate(100%, 0);
}
.fade-leave-to {
  transform: translate(-100%, 0);
}
</style>

<style lang="scss">
.navbar_section {
  width: 100%;
}

.padding_menu {
  padding: 0.5rem 1rem;
  transition: all 0.2s !important;
}

.text-fill-color-initial .dropdown-menu.show {
  -webkit-text-fill-color: initial;
}

.shortcut_title {
  font-size: 18px;
  font-weight: 700;
  line-height: 39px;
  letter-spacing: 0.275em;
}

.shortcuts {
  text-align: left;
  margin-bottom: 50px;
}

.shortcut_container {
  margin-top: auto;
  margin-bottom: auto;
  width: 100%;
}

.image_menu {
  max-height: 100%;
  width: 60%;
  cursor: pointer;
  padding: 2px 10px;
}

@media (max-width: 768px) {
  .navbar {
    padding: 0 !important;
    flex-direction: column;
  }
  .container_menu {
    width: 100%;
  }
  .header_footer {
    width: 100%;
    padding: 1.5rem 10%;
    background: rgba(255, 253, 253, 0.95);
    text-align: center;
    position: relative;
    display: grid;
    justify-items: center;
    color: #4a4a4a;
    -webkit-text-fill-color: initial !important;
  }

  .full-height {
    min-height: 100%;
  }
}

@media (min-width: 768px) {
  .navbar {
    padding: 0 5%;
  }
}

#toolbar {
  @media (max-width: 768px) {
    .padding_menu {
      width: 100%;
      display: flex;
    }
    .navbar-brand {
      flex-grow: 1;
    }
    .navbar_section {
      height: 100%;
      display: flex;
      flex-flow: column;
    }
    #toolbar-menu {
      height: 100%;
      display: flex;
      flex-direction: column;

      .return_link {
        background-color: lightgray !important;
        text-align: center;
        border-bottom: none;
      }

      .toolbar-links {
        width: 100%;
        padding: 0.5rem 1rem;
        background: #e5e5e5;
        flex-grow: 1;
      }

      ul {
        width: 100%;
      }

      li {
        margin-top: 1rem;
        width: 100%;
        border-bottom: 0.5px solid black;
        padding-left: 1rem;
        padding-right: 1rem;
      }
    }
  }

  &[data-type="white"] {
    .navbar-nav .nav-link,
    .menu-icon {
      color: white !important;
    }
  }

  &[data-type="black"] {
    .navbar-nav .nav-link,
    .menu-icon {
      color: black !important;
    }

    .menu-icon-white {
      color: white !important;
    }
  }

  &[data-style="transparent"] {
    background: transparent;

    @media (max-width: 768px) {
      .overlap-image {
        -webkit-text-fill-color: initial !important;
      }
    }
  }

  &[data-style="white"] {
    .padding_menu {
      background: white;
    }

    @media (min-width: 768px) {
      background: white;
    }
  }
}
</style>